//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import {PublicAppLayout} from 'app_components/layouts/public'
import BannerTextPrimaryCommon from 'app_components/commons/bannertextprimary'
import AllThingsModule from 'app_components/modules/academic/allthings'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../capsulasScreen.scss'
import TextComponent from 'app_components/commons/TextComponent/TextComponent'

// @ADD Component types
interface ICapsulasScreenLayoutProps {}

const CapsulasScreenLayout: React.FC<ICapsulasScreenLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <PublicAppLayout>
      <div className="capsulas-screen--layout">
        <TextComponent type='title' as='h2' textTransform='none'>Cápsula</TextComponent>
        <AllThingsModule type={'capsules'}/>
      </div>
    </PublicAppLayout>
  )
}

export default CapsulasScreenLayout
